import type { ProductListingPageStoryblok } from "@/generated/sb/sb-types";
import { type BlokProps } from "@frend-digital/storyblok";

// eslint-disable-next-line no-empty-pattern
export const ProductListingPageBlok = ({}: BlokProps<ProductListingPageStoryblok>) => {
	return <></>;
};
